import React from 'react';
import './ScrollStack.css';

/**
 * ScrollStack Component
 * * Wraps children components and applies a "sticky stack" effect.
 * Each child slides over the previous one.
 * * @param {Object} props
 * @param {React.ReactNode} props.children - The sections to stack
 * @param {boolean} props.enableScale - Optional: Adds a subtle scale effect to background cards (Desktop only)
 */
const ScrollStack = ({ children, enableScale = false }) => {
  // Convert children to array to map safely
  const items = React.Children.toArray(children);

  return (
    <div className="scroll-stack-wrapper1">
      {items.map((child, index) => (
        <div 
          key={index} 
          className="scroll-stack-item"
          style={{ 
            // Ensure each subsequent item sits On Top of the previous one
            zIndex: index + 1,
            // Optional: You can add a slight top offset if you want a "Card Deck" look
            // For full sections, we usually keep this at 0.
            top: 0 
          }}
        >
          {child}
        </div>
      ))}
    </div>
  );
};

export default ScrollStack;